import api from './api';

export interface Area {
  id: string;
  nome: string;
  sigla?: string;
  descricao?: string;
  usuarioId?: string;
  diretoriaId: string;
  diretoria?: string;
  usuarioSubstitutoId?: string;
  dataFinal?: Date;
  dataInicial?: Date;
}

export const getAllAreas = () => api.get<Area[]>('areas');
export const getAreasByDiretoria = (diretoriaId: any) => api.get<Area[]>(`areas/diretoria/${diretoriaId}`);
export const createArea = (area: Area) => {
  return api.post<any>('areas', area);
};
export const updateArea = (area: Area) => api.put<any>(`areas/${area.id}`, area);
export const deleteArea = (id: string) => api.delete(`areas/${id}`);
export const getAllAreasByDiretoriaOptions = (diretoriaId: any) =>
  getAreasByDiretoria(diretoriaId).then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
export const getAllAreasOptions = () =>
  getAllAreas().then(areas => (areas || []).map(a => ({ text: a.nome, value: a.id.toString() })));
